import { Controller } from "@hotwired/stimulus"
import Picker from "vanilla-picker"


export default class extends Controller {
  static targets = ["inputField", "preview"]
  static values = {
    targetAttribute: String,
    targetSelector: String
  }

  connect() {
    this.picker = new Picker({
      parent: this.previewTarget,
      color: this.currentColor,
      alpha: false,
      editorFormat: "hex",
      onChange: (color) => {
        const colorWithoutAlpha = color.hex.substring(0, 7)
        this.previewTarget.style.backgroundColor = colorWithoutAlpha
        this.inputFieldTarget.value = colorWithoutAlpha

        this.setPlayerPreviewColor(colorWithoutAlpha)
      }
    })
  }

  showPicker() {
    setTimeout(() => {
      this.picker.show()
    }, 200);
  }

  setPlayerPreviewColor(color) {
    if (!this.targetElement) { return }

    this.targetElement.setAttribute(this.targetAttributeValue, color)
  }

  get currentColor() { return this.inputFieldTarget.value }
  get targetElement() {
    if (!this.targetSelectorValue) { return }

    return document.querySelector(this.targetSelectorValue)
  }
}
